import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { environment } from "@env/environment";
import { Passenger, Reservation } from "@app/models";
import { BagAncillarieInt, BagPassangerInt, IssueBagInt, IssueBagsDTO } from "@interfaces/*";
import { BagMapper } from "@app/mappers";
import { catchError, map } from "rxjs/operators";
import { Observable, Subject, throwError } from "rxjs";
import { ResponsePNRUdateInt } from "@app/interfaces/responsePNRUpdate.interface";
import { LoadingService } from './loading.service';
import {  TypeLoading } from '@app/enums';
import {ErrorAdapter} from "@models/adapter/error.adapter";
import { MAX_HEIGHT } from '@app/constants/kiosk-resolution-routes.constant';

@Injectable({
  providedIn: 'root'
})
export class BagsService {
  private url = environment.urlApi;
  private mapper = new BagMapper();
  private _issueBagTag: IssueBagInt;
  updateTableGlobalStatus$ = new Subject<boolean>();

  constructor(
    private http: HttpClient,
    private _loadingService: LoadingService
  ) { }

  /*Deprecado
  getissueBagTag(passenger: Passenger, bag: BagPassangerInt, cartId: string): Observable<IssueBagInt> {
    const data = this.mapper.dataBagToReqtIssueBagTag(passenger, bag);
    return this.http.put<IssueBagsDTO>(`${this.url}/issueBagTag/${cartId}`, data).pipe(
      map((response): IssueBagInt => {
        return {
          bagTagInfo: response.bagTagInfo,
          bagTagNumber: response.bagTagNumber,
          currentBag: bag,
          passenger,
        }
      }), catchError(this.handlerError.bind(this))
    )
  }*/

  set issueBagTag(data: IssueBagInt) {
    this._issueBagTag = data;
  }
  get isueBagTag(): IssueBagInt {
    return this._issueBagTag;
  }

  bagRedeem(passenger: Passenger, cartId: string, extraAncillaries: BagAncillarieInt[], tierLevel: string, legCode: string) {
    this._loadingService.showLoading(TypeLoading.FOOTER_LOADING);
    return this.http.put<ResponsePNRUdateInt>(`${this.url}/carts/${cartId}`,
      this.mapper.mapRedeemBagRquest(passenger, extraAncillaries, tierLevel, legCode))
      .pipe(
        map((response) => {
          this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
          return this.mapper.mapRedeemBagDTOtoResponse(response, passenger.id)
        }),
        catchError(this.handlerError.bind(this))
      )
  }

  updateSelectBagsMiddleware(passenger:Passenger){
    const indexMiddlewareSelect = passenger.bagStack.findIndex(bag => bag.selected && !bag.used);
    for (const [index, bag] of passenger.bagStack.entries()) {
      if (index < indexMiddlewareSelect && !bag.used) {
        bag.selected = true;
      }
    }
    this.updateTableGlobalStatusBags(true);
  }

  updateTableGlobalStatusBags(update:boolean){
    this.updateTableGlobalStatus$.next(update);
  }

  getUpdateTableGlobalStatusBags(){
    return this.updateTableGlobalStatus$.asObservable();
  }


  bagCarryOnUpdate(resevation: Reservation, cartId: string) {
    return this.http.put<ResponsePNRUdateInt>(`${this.url}/carts/${cartId}`,
      this.mapper.mapCarryOnBagRquest(resevation))
  }
  handlerError(error: HttpErrorResponse) {
    const errorAdapt = ErrorAdapter.adapt(error.error);
    return  throwError(errorAdapt);
  }
}
